import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/crecordxl/list", params, successCallback, failCallback, exceptionCallback);
	},listSnameAtDay: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/crecordxl/listSnameAtDay", params, successCallback, failCallback, exceptionCallback);
	},listByUname: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/crecordxl/listByUname", params, successCallback, failCallback, exceptionCallback);
	},cntMthDatas: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/crecordxl/cntMthDatas", params, successCallback, failCallback, exceptionCallback);
	},save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/consu/crecordxl/save", params, successCallback, failCallback, exceptionCallback);
	},toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/crecordxl/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/consu/crecordxl/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/consu/crecordxl/remove", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
